import { Inject, Injectable, Optional } from '@angular/core';
import { EnvSettings } from '@core-shared/models/env-settings';

@Injectable({providedIn: 'root'})
export class EnvService {
  public settings?: EnvSettings;

  constructor(@Inject('envSettings') @Optional() envSettings?: EnvSettings) {
    this.settings = envSettings;
  }
}

// TODO handle error-case?
export async function fetchEnvVariables(): Promise<EnvSettings> {
  return fetch(`assets/env.json?rnd=${Math.random()}`)
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      else if (!contentType || !contentType.includes('application/json')) {
        throw new TypeError('fetched env.json received as' + contentType);
      }
      return response.json();
    });
}
